<template>
    <PickForeground type="Delivery Order"/>
</template>

<script>
import PickForeground from '@/views/pick/Foreground.vue';

export default {
    components:{
        PickForeground
    },
}
</script>